import { ProjectContactForm } from './ProjectContactForm';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { ReportButton } from '@/components/ReportButton';

interface ProjectContactSidebarProps {
  projectId: string;
  referenceCode?: string;
}

export function ProjectContactSidebar({ projectId, referenceCode }: ProjectContactSidebarProps) {
  return (
    <div className="hidden lg:block sticky top-24 space-y-4">
      <div className="border rounded-xl overflow-hidden">
        <div className="flex">
          <Button className="flex-1 rounded-none h-12 text-sm font-bold gap-2" asChild>
            <a href="tel:+251">
              <Phone className="h-4 w-4" /> Call Now
            </a>
          </Button>
          <Button variant="outline" className="rounded-none h-12 w-14 border-l-0" asChild>
            <a href="https://wa.me/251" target="_blank" rel="noopener noreferrer">
              <MessageCircle className="h-5 w-5 text-primary" />
            </a>
          </Button>
        </div>

        <div className="p-5">
          <div className="flex items-center gap-3 mb-4">
            <Separator className="flex-1" />
            <span className="text-xs text-muted-foreground">or</span>
            <Separator className="flex-1" />
          </div>

          <ProjectContactForm projectId={projectId} referenceCode={referenceCode} />
        </div>
      </div>

      <div className="border rounded-xl p-3 bg-muted/40">
        <ReportButton
          targetType="project"
          targetId={projectId}
          variant="outline"
          className="w-full border-destructive/30 text-destructive hover:bg-destructive hover:text-destructive-foreground font-semibold text-sm"
          label="Report this project"
        />
      </div>
    </div>
  );
}
